import styled from 'styled-components';

export const FormS = styled.form`
  padding: 18px 20px;
  display: ${({ showForm }) => showForm ? 'block' : 'none'};
  overflow-y: ${({ withoutOverflowY }) => withoutOverflowY ? 'none' : 'auto'};
`;



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/meeting-notes-form/styled-components.js